// =============================================================================
// Ferramentas: os rótulos e as cores da planilha, para as telas
//
// À parte das páginas para as abas (Ferramentas.tsx e FerramentasAbas.tsx)
// usarem sem uma importar a outra.
// =============================================================================

import type { Ferramenta } from "./api.ts";

/** Os rótulos de status da planilha. */
export const ROTULO_STATUS_FERRAMENTA: Record<Ferramenta["status"], string> = {
  ativa: "Ativo", verificar: "Verificar", nova: "NOVO-Validar", cancelada: "Cancelado",
};

/** A legenda de cores da aba Instruções: a cor da célula de status e a da linha. */
export const COR_STATUS: Record<Ferramenta["status"], { celula: string; linha: string }> = {
  ativa: { celula: "bg-ok-bg text-ok-tinta", linha: "" },
  // Cores opacas na linha: a coluna da ferramenta fica presa à esquerda, e com
  // fundo translúcido o que rola por baixo dela apareceria através.
  verificar: { celula: "bg-atencao-bg text-atencao-tinta", linha: "bg-atencao-bg" },
  nova: { celula: "bg-laranja/20 text-laranja-tinta", linha: "bg-[color-mix(in_srgb,var(--color-laranja)_12%,var(--color-superficie))]" },
  cancelada: { celula: "bg-risco-bg text-risco-tinta", linha: "" },
};

/** "2026-06-29" → "29/06/26", como a planilha escreve. */
const dataCurta = (iso: string) => { const [a, m, d] = iso.split("-"); return `${d}/${m}/${a!.slice(2)}`; };

export function rotuloStatus(f: Pick<Ferramenta, "status" | "cancelada_em" | "texto_planilha">): string {
  if (f.texto_planilha?.status) return f.texto_planilha.status;
  if (f.status === "cancelada" && f.cancelada_em) return `Cancelado ${dataCurta(f.cancelada_em)}`;
  return ROTULO_STATUS_FERRAMENTA[f.status];
}

/** "24300" → "US$ 243,00". */
export function dolar(centavos: string | null): string {
  if (!centavos) return "—";
  const v = BigInt(centavos);
  return `US$ ${new Intl.NumberFormat("pt-BR").format(v / 100n)},${(v % 100n).toString().padStart(2, "0")}`;
}

export const ROTULO_FORMA: Record<string, string> = {
  cartao: "Cartão", boleto: "Boleto", pix: "Pix", transferencia: "Transferência", outro: "Outro",
};
export function textoForma(f: Pick<Ferramenta, "forma_pagamento" | "cartao_final" | "texto_planilha">): string {
  if (f.texto_planilha?.forma_pagamento) return f.texto_planilha.forma_pagamento;
  if (!f.forma_pagamento) return "";
  const r = ROTULO_FORMA[f.forma_pagamento] ?? f.forma_pagamento;
  return f.cartao_final ? `${r} - Final ${f.cartao_final}` : r;
}
